import React from 'react';
import styles from './WeeklyOrActionTable.module.css';

const getColumnColor = (value) => {
  if (value < 80) return styles.textRed;
  if (value < 95) return styles.textYellow;
  return styles.textGreen;
};

export default function WeeklyOrActionTable({ data, isOn }) {

  if (!Array.isArray(data) || data.length === 0 || !data[0]) return null;  

  const displayData = isOn
    ? Object.keys(data[0]).sort((a, b) => Number(a.replace("Week ", "")) - Number(b.replace("Week ", "")))
    : Object.keys(data[0]).sort((a, b) => Number(a.replace("Week ", "")) - Number(b.replace("Week ", ""))).slice(-4);

  const topKeys = data[0]?.[displayData?.[displayData.length - 1]];
  if (!displayData || !Array.isArray(topKeys)) return null;

  return (
    <div className={`${styles.wrapper} no-scrollbar border-box`}>
      <div className={styles.headerColumn}>
        <div className={`${styles.headerCell}`} />
        {topKeys.map((item, index) => (
          <div key={index} className={styles.headerItem}>
            {item.week}
          </div>
        ))}
      </div>

      {displayData.map((weekLabel, index) => {
        const currData = data[0]?.[weekLabel];
        if (!Array.isArray(currData)) return null;

        return (
          <div key={index} className={styles.dataColumn}>
            {currData.isCurrent && (
              <>
                <div className={styles.activeDotWrapper}>
                  <div className={styles.activeDot}></div>
                </div>
                <div className={styles.activeOverlay}></div>
              </>
            )}

            <div className={styles.weekLabel}>{weekLabel}</div>

            {currData.map((entry, idx) => (
              <React.Fragment key={idx}>
                <div className={styles.dataCell}>
                  <span className={`${styles.textSmall} ${styles.textMuted}`}>
                    {entry.projected}
                  </span>
                </div>
                <div className={styles.dataCell}>
                  <span className={`${styles.textSmall} ${getColumnColor(Number(entry.plan))}`}>
                    {entry.plan}
                  </span>
                </div>
              </React.Fragment>
            ))}
          </div>
        );
      })}
    </div>
  );
}
